import React from 'react';

const Header: React.FC = () => {
  return (
    <header className="bg-white shadow-sm border-b border-gray-200">
      <div className="px-6 py-4">
        <h2 className="text-xl font-semibold text-gray-800">Dashboard</h2>
      </div>
    </header>
  );
};

export default Header;

